import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content', 'chevron']

  connect() {
    console.log('Collapsible filters controller connected')
    // Start collapsed
    this.isExpanded = false
    this.contentTarget.style.maxHeight = '0px'
    this.contentTarget.style.opacity = '0'
  }

  toggle(event) {
    console.log('Toggle clicked, current state:', this.isExpanded)
    event.preventDefault()
    event.stopPropagation()

    if (this.isExpanded) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand() {
    console.log('Expanding filters')

    // First make it visible but with 0 height
    this.contentTarget.style.opacity = '1'

    // Get the natural height of the content
    this.contentTarget.style.maxHeight = 'none'
    const naturalHeight = this.contentTarget.scrollHeight
    console.log('Natural height:', naturalHeight)

    // Reset to 0 then animate
    this.contentTarget.style.maxHeight = '0px'

    // Force reflow then animate to natural height
    requestAnimationFrame(() => {
      this.contentTarget.style.maxHeight = naturalHeight + 'px'
      if (this.hasChevronTarget) {
        this.chevronTarget.style.transform = 'rotate(180deg)'
      }
    })

    this.isExpanded = true

    // Clean up max-height after animation completes
    setTimeout(() => {
      if (this.isExpanded) {
        this.contentTarget.style.maxHeight = 'none'
      }
    }, 300)
  }

  collapse() {
    console.log('Collapsing filters')

    // Set explicit height first
    const currentHeight = this.contentTarget.scrollHeight
    this.contentTarget.style.maxHeight = currentHeight + 'px'

    // Force reflow then animate to 0
    requestAnimationFrame(() => {
      this.contentTarget.style.maxHeight = '0px'
      this.contentTarget.style.opacity = '0'
      if (this.hasChevronTarget) {
        this.chevronTarget.style.transform = 'rotate(0deg)'
      }
    })

    this.isExpanded = false
  }
}
